import Button from "@material-ui/core/Button";
import React from "react";

const SaveButton: any = (props: any) => {
  const { isDisabled, handlerClick} = props;

  return (
    <Button disabled={isDisabled} variant={"contained"} onClick={handlerClick}>
      {"Сохранить"}
    </Button>
  )
}

export default SaveButton;